<template>
  <MainLayout :title="$t('pages.usage')">
    <template slot="leftElements">
      <ChartFilters page="usage" />
    </template>
    <template slot="rightElements">
      <VsDatePicker v-if="selectedDateRange" :selectedDate="selectedDateRange" @changedDate="changedDate" />
    </template>
    <div slot="content">
      <ChartSelector :activeUsage="activeUsage" :usageData="usageData" />
      <RateAndTotalChart :rateTotalData="activeUsageData" />
      <DataTableWrapper :activeUsage="activeUsage" :usageData="usageData" />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/Main";
import ChartSelector from "@/components/usage/ChartSelector/Index";
import RateAndTotalChart from "@/components/shared/RateAndTotalChart/Index";
import DataTableWrapper from "@/components/usage/DataTable/Index";
import ChartFilters from "@/components/shared/ChartFilters/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    MainLayout,
    ChartSelector,
    RateAndTotalChart,
    DataTableWrapper,
    ChartFilters,
  },
  computed: {
    ...mapGetters({
      selectedDateRange: "usage/selectedDateRange",
      activeUsage: "usage/activeUsage",
      usageData: "usage/usageData",
      activeFilters: "filters/getAllActiveFilters",
    }),
    activeUsageData() {
      return this.usageData[this.activeUsage];
    },
  },
  created() {
    if (!this.selectedDateRange) {
      this.initDateRange();
    }
  },
  methods: {
    ...mapActions("usage", ["initDateRange", "setDateRange"]),
    changedDate(changedDate) {
      this.setDateRange({
        startDate: changedDate.start,
        endDate: changedDate.end,
      });
    },
  },
};
</script>
